import type { SpecialFeature } from '../specialFeature'
import type { Facet } from './type'

export function specialFeatureToFacet(specialFeature?: SpecialFeature): Facet[] {
  if (specialFeature === undefined) {
    return []
  }
  return [
    {
      label: specialFeature.name,
      facetKey: '',
      add: (current) => current ?? {},
      remove(current) {
        const { specialFeatureId, ...rest } = current ?? {}
        return rest
      },
      selected: (criteria) => criteria?.specialFeatureId !== undefined,
      showInList: (criteria) => criteria?.specialFeatureId !== undefined,
    },
  ] satisfies Facet[]
}
